import VxeSelectComponent from './src/select';
import { dynamicApp } from '../dynamics';
export var VxeSelect = Object.assign(VxeSelectComponent, {
    install: function (app) {
        app.component(VxeSelectComponent.name, VxeSelectComponent);
    }
});
export var Select = VxeSelect;
dynamicApp.component(VxeSelectComponent.name, VxeSelectComponent);
export default VxeSelect;
